import EventBus from './Event';

class FormSteps {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.formName = this.$el.data('name');
    
    this.$progressStepsWrap = $(document.body).find(`[data-form-steps="${this.formName}"]`);
    this.$progressSteps = this.$progressStepsWrap.find(`[data-progress-step]`);
    this.$steps = this.$el.find('[data-form-step]');
    this.$actionSave = this.$el.find('[data-form-action="save"');
    this.$actionNext = this.$el.find('[data-form-action="next"');
    this.$actionBack = this.$el.find('[data-form-action="back"');
    this.$actionSubmit = this.$el.find('[data-form-action="submit"');

    this.currentStep = 1;
    this.totalSteps = this.$steps.length;
    this.isSaving = true;
    this.canAdvanceStep = true;

    this.onClickNext = this.onClickNext.bind(this);
    this.onClickProgressStep = this.onClickProgressStep.bind(this);

    this.initUI();
    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  initUI() {
    this.$steps.addClass('inactive');
    this.$progressSteps.removeClass('done').removeClass('is_current_step');
    this.$progressSteps.next().removeClass('done');
    this.$actionSubmit.hide();
    this.navigateToStep(this.currentStep);
  }

  navigateToStep(stepIndex) {
    if (stepIndex != 1) {
      EventBus.emit('form-steps:before-navigate', stepIndex);
    }
    
    if (!this.canAdvanceStep && stepIndex > this.currentStep) {
      return false;
    }
    this.currentStep = stepIndex;

    // update form steps visibility
    const $step = this.$steps.filter(`[data-form-step="${stepIndex}"]`);
    this.$steps.removeClass('active').addClass('inactive');
    $step.removeClass('inactive').addClass('active');

    // update progress steps styles
    // reset
    this.$progressSteps.removeClass('done').removeClass('is_current_step');
    this.$progressSteps.next().removeClass('done');
    // add 'done' styles to previous progress steps
    const $prevProgressSteps = this.$progressSteps.filter((i, el) => {
      return +$(el).data('progress-step') < this.currentStep;
    });
    $prevProgressSteps.addClass('done');
    // add 'is_current_step' styles to current step
    const $currentProgressStep = this.$progressSteps.filter(`[data-progress-step="${this.currentStep}"]`);
    $currentProgressStep.addClass('is_current_step');
    // add 'done' styles to progress lines
    this.$progressSteps.filter('.done, .is_current_step').next().addClass('done');

    // show/hide action buttons
    if (this.currentStep < this.totalSteps) {
      this.$actionNext.show();
      this.$actionSubmit.hide();
    } else {
      this.$actionNext.hide();
      this.$actionSubmit.show();
    }

    // show/hide back button
    if (this.currentStep > 1) {
      this.$actionBack.show();
    } else {
      this.$actionBack.hide();
    }

    // emit event
    EventBus.emit('form-steps:navigate', {
      formName: this.formName,
      step: this.currentStep,
    });
  }

  bindEvents() {
    this.$actionNext.on('click', this.onClickNext);
    this.$actionBack.on('click', this.onClickBack.bind(this));
    this.$progressSteps.on('click', this.onClickProgressStep);
    this.$actionSave.on('click', this.onClickSave);

    EventBus.on('form-steps:validation', this.onFormValidation.bind(this));
    EventBus.on('offer-request:clear', this.navigateToStep.bind(this, 1));
  }

  // Event Handlers
  onClickNext(e) {
    e.preventDefault();
    // @TODO: save
    this.navigateToStep(this.currentStep + 1);

    // scroll
    window.scrollTo({
      top: 300,
      behavior: 'smooth'
    });
  }

  onClickBack(e) {
    e.preventDefault();
    this.navigateToStep(this.currentStep - 1);
  }

  onClickProgressStep(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    if (!$target.hasClass('done')) return false;
    
    const step = +$target.data('progress-step');
    this.navigateToStep(step);
  }

  onClickSave(e) {
    e.preventDefault();

  }

  onFormValidation(canAdvance) {
    this.canAdvanceStep = canAdvance;
  }

  saveProgress() {
    this.isSaving = true;
    
  }

  static init() {
    $('[data-js-component="form-steps"]').each((i, el) => new FormSteps(el));
  }
}

FormSteps.init();